import { useCoursesStore } from '~~/stores/courses'
import { usePaymentStore } from '~~/stores/payment'
import type { VoucherType } from '#build/stores/payment/types'

const useFetch = ({ emits }) => {
  const route = useRoute()
  const { getQueryStringFromObject } = useQueryString()
  const coursesStore: Record<string, any> = useCoursesStore()
  const courseDetail = computed(() => coursesStore.state.courseDetail)
  const isPlaylistCourseDetail = computed(
    () => route.name === 'partnerplaylist-slug-kursus-slugkursus'
  )
  const paymentStore: Record<string, any> = usePaymentStore()

  const coursePrice = computed(() =>
    courseDetail?.value?.data?.priceDiscount > 0
      ? courseDetail?.value?.data?.priceDiscount
      : courseDetail?.value?.data?.priceNormal
  )

  const priceDiscountVoucher = computed(() => {
    switch (selectedVoucher.value?.discountType) {
      case 'percentage':
        return coursePrice.value * (selectedVoucher.value?.discountValue / 100)
      case 'amount':
        return selectedVoucher.value?.discountValue
      case 'new_price':
        return coursePrice.value - selectedVoucher.value?.discountValue
      default:
        return 0
    }
  })

  const amount = computed(() => {
    return selectedVoucher.value?.discountType === 'new_price'
      ? selectedVoucher.value?.discountValue
      : coursePrice.value - priceDiscountVoucher.value
  })

  const showConfirmation = ref(false)

  const selectedVoucher = ref<VoucherType>(null)
  const showVoucherList = ref<boolean>(false)
  const isLoadingSubmit = ref<boolean>(false)

  const cancelBuyCourse = () => {
    if (selectedVoucher?.value) {
      showConfirmation.value = true
    } else {
      triggerCloseConfirmation()
    }
  }

  const triggerCloseConfirmation = () => {
    showConfirmation.value = false
    selectedVoucher.value = null
    emits('cancel')
  }

  const triggerback = (value) => {
    selectedVoucher.value = value
    showVoucherList.value = false
  }

  const checkoutCourse = () => {
    isLoadingSubmit.value = true
    const urlPath = window?.location?.href
    paymentStore.checkoutCourse({
      payload: {
        courseSerial: courseDetail?.value?.data?.serial,
        voucherSerial: selectedVoucher?.value?.serial ?? null,
        successRedirectURL: `${urlPath}?payment=success`,
        failureRedirectURL: `${urlPath}payment=failed`
      },
      resolve: (res) => {
        isLoadingSubmit.value = false
        const payload: Record<string, any> = {
          slugCourse: isPlaylistCourseDetail.value
            ? route.params?.slugkursus
            : route.params?.slug
        }

        if (isPlaylistCourseDetail.value) {
          payload.params = getQueryStringFromObject({
            groupSlug: route.params?.slug
          })
        }

        if (res?.status === 'SUCCEEDED') {
          coursesStore?.fetchCourseDetail({
            payload,
            resolve: () => {
              emits('success')
            }
          })
        } else {
          window.open(res?.invoiceURL, '_blank')
        }
      },
      reject: () => {
        isLoadingSubmit.value = false
      }
    })
  }

  return {
    courseDetail,
    amount,
    showConfirmation,
    showVoucherList,
    selectedVoucher,
    cancelBuyCourse,
    triggerCloseConfirmation,
    triggerback,
    checkoutCourse,
    priceDiscountVoucher
  }
}

export default useFetch
